// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#begin_checkout
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackBeginCheckoutItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackBeginCheckoutParameters
    extends TrackEventListParameters<"currency" | "value" | "coupon", null, TrackBeginCheckoutItem> {}

const trackBeginCheckout = (parameters: TrackBeginCheckoutParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "begin_checkout", ...parameters }, options);
};

export default trackBeginCheckout;
